
import { ControlElement } from '@jsonforms/core';
import { defineComponent, computed, toRaw } from 'vue';
import { rendererProps, useJsonFormsControl, RendererProps } from '@jsonforms/vue';
import { useClearOnRefresh, useAutoSetOnChange, useApiCallResource } from '../../util';

const controlRenderer = defineComponent({
  name: 'string-control-renderer',
  components: {},
  props: {
    ...rendererProps<ControlElement>(),
    itemLabel: {
      type: String,
    },
  },
  data() {
    return {
      disable: false,
      isTouched: false,
      search: '',
    };
  },
  mounted() {
    if (
      this.control?.data?.length &&
      !this.control?.uischema?.options?.editable &&
      !this.control?.config?.editableHydratedFields
    ) {
      this.disable = true;
    }
    // Don't call onChange here to avoid triggering validation on mount
    // this.onChange(this.control.data);
  },
  methods: {
    onBlur() {
      this.isTouched = true;
    },
    onFocus() {
      // Optionally mark as touched on focus as well
      // this.isTouched = true;
    },
    onChange(value: any) {
      // Mark as touched when user changes the value
      this.isTouched = true;
      
      if (this.control?.uischema?.options?.toUppercase) {
        this.handleChange(this.control.path, value ? toRaw(value.toUpperCase()) : undefined);
      } else {
        this.handleChange(this.control.path, value && value.length ? toRaw(value) : undefined);
      }
    },
  },
  setup(props: RendererProps<ControlElement>) {
    const input = useJsonFormsControl(props);
    useClearOnRefresh(input.control, input.handleChange);
    const { filteredOptions, isApiLoading, filterFn } = useApiCallResource(input.control);
    const hasResource = computed(() => !!(input.control.value?.schema as { resource?: unknown })?.resource);
    useAutoSetOnChange(input.control, input.handleChange);
    return { ...input, filteredOptions, isApiLoading, filterFn, hasResource };
  },
});

export default controlRenderer;
